'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import CheckboxInput from '@/components/V2/CheckboxInput/CheckboxInput';
import Modal from '@/components/V2/Modal/Modal';
import RectButton from '@/components/V2/RectButton/RectButton';
import { useTermsAcceptance } from '@/hooks/onboarding/useTermsAcceptance';
import { useTermsOfUseStore } from '@/hooks/Stores/useTermsOfUseStore';
import { translate } from '@/lib/i18n/translate';
import styles from './TermsOfUseAcceptance.module.css';
function TermsOfUseAcceptanceContent() {
  const $ = _c(21);
  const [hasAccepted, setHasAccepted] = useState(false);
  const {
    termsOfUseUrl,
    accept,
    isLoading
  } = useTermsAcceptance();
  const closeTermsModal = useTermsOfUseStore(_temp);
  let t0;
  if ($[0] !== accept || $[1] !== closeTermsModal) {
    t0 = async () => {
      try {
        await accept();
      } catch {
        return;
      }
      closeTermsModal();
    };
    $[0] = accept;
    $[1] = closeTermsModal;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleSubmit = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h3 className={styles.greet}>{translate("COMPONENTS.TERMS_OF_USE_MODAL.GREET")}</h3>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className={styles.message}>{translate("COMPONENTS.TERMS_OF_USE_MODAL.TITLE")}<br /><br />{translate("COMPONENTS.TERMS_OF_USE_MODAL.MESSAGE")}</p>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = t5 => {
      const {
        target
      } = t5;
      return setHasAccepted(target.checked);
    };
    t4 = translate("COMPONENTS.TERMS_OF_USE_MODAL.CTA");
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  const t5 = termsOfUseUrl ?? undefined;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = translate("COMPONENTS.TERMS_OF_USE_MODAL.ANCHOR");
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <span>{t4}<a className={styles.link} href={t5} target="_blank" rel="noopener noreferrer" onClick={_temp2}>{t6}</a></span>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== hasAccepted || $[11] !== t7) {
    t8 = <div className={styles.acceptance}><CheckboxInput data-testid="terms-of-use-checkbox" checked={hasAccepted} onChange={t3} label={t7} /></div>;
    $[10] = hasAccepted;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !hasAccepted || isLoading || !termsOfUseUrl;
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = translate("COMPONENTS.TERMS_OF_USE_MODAL.SUBMIT");
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== handleSubmit || $[15] !== isLoading || $[16] !== t9) {
    t11 = <RectButton fullWidth={true} data-testid="terms-of-use-submit" variant="primary" type="button" disabled={t9} isLoading={isLoading} onClick={handleSubmit}>{t10}</RectButton>;
    $[14] = handleSubmit;
    $[15] = isLoading;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t8) {
    t12 = <div className={styles.termsOfUse}>{t1}{t2}{t8}{t11}</div>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}

/**
 * Blocking terms-of-use acceptance modal.
 *
 * Opened by the API error interceptors when the backend rejects a call with
 * `TERMS_OF_USE_NOT_ACCEPTED` — which is what a freshly onboarded user hits on
 * their first authenticated request after coming back from SYNC. Mounted once,
 * globally, in `providers.tsx`.
 *
 * The content is a separate component so its queries only run once the modal is
 * actually open, instead of on every page load for every user.
 */
function _temp2(event) {
  return event.stopPropagation();
}
function _temp(state) {
  return state.closeTermsModal;
}
export default function TermsOfUseAcceptance() {
  const $ = _c(1);
  const isVisible = useTermsOfUseStore(_temp3);
  if (!isVisible) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Modal isVisible={true} displayCloseButton={false} testID="terms-of-use-modal" content={<TermsOfUseAcceptanceContent />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp3(state) {
  return state.isVisible;
}